// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var React = require("react");
var Atom_Box = require("../atom/Atom_Box.bs.js");
var Atom_Row = require("../atom/Atom_Row.bs.js");
var Particle_Color = require("../particle/Particle_Color.bs.js");
var Particle_zIndex = require("../particle/Particle_zIndex.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function make(style) {
  return {
          justifyContent: Particle_Screen_Constants.justifyContentCenter,
          alignItems: Particle_Screen_Constants.alignItemsCenter,
          background: Particle_Background_Ds.badge
        };
}

function view(param) {
  return {
          justifyContent: param.justifyContent,
          alignItems: param.alignItems,
          background: param.background
        };
}

var Molecule_Badge_Ds = {
  make: make,
  view: view
};

function toCss(style) {
  return Particle_Screen_Ds.make(undefined, undefined, [
              CssJs.top({
                    NAME: "px",
                    VAL: 8
                  }),
              CssJs.left({
                    NAME: "px",
                    VAL: 30
                  })
            ], [CssJs.left({
                    NAME: "px",
                    VAL: 20
                  })], undefined, [
              CssJs.width(CssJs.px(15)),
              CssJs.height(CssJs.px(15)),
              CssJs.cursor("pointer"),
              CssJs.borderRadius(CssJs.pct(40)),
              CssJs.border(CssJs.px(2), CssJs.solid, Particle_Color.Css.color("Background")),
              CssJs.position("absolute"),
              CssJs.top({
                    NAME: "px",
                    VAL: 0
                  }),
              CssJs.left({
                    NAME: "px",
                    VAL: 22
                  }),
              Particle_zIndex.Particle_zIndex_Css.toCss({
                    TAG: /* Exact */0,
                    _0: /* Badge */0
                  })
            ]);
}

var Molecule_Badge_Css = {
  toCss: toCss
};

function Molecule_Badge(Props) {
  var style = Props.style;
  var children = Props.children;
  var match = view({
        justifyContent: Particle_Screen_Constants.justifyContentCenter,
        alignItems: Particle_Screen_Constants.alignItemsCenter,
        background: Particle_Background_Ds.badge
      });
  var rules = toCss(style);
  return React.createElement(Atom_Row.make, {
              children: null
            }, children, React.createElement(Atom_Box.make, {
                  alignItems: match.alignItems,
                  background: match.background,
                  justifyContent: match.justifyContent,
                  rules: rules
                }));
}

var make$1 = Molecule_Badge;

exports.Molecule_Badge_Ds = Molecule_Badge_Ds;
exports.Molecule_Badge_Css = Molecule_Badge_Css;
exports.make = make$1;
/* CssJs Not a pure module */
